export default "__VITE_ASSET__9c9665fc__"